/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SlutopgoerelseAfregnRequestDto as OkEgisServiceModelsDtoSlutopgoerelseAfregnRequestDto } from '../models/OK/Egis/Service/Models/DTO/slutopgoerelse-afregn-request-dto';
import { SlutopgoerelseDraftDto as OkEgisServiceModelsDtoSlutopgoerelseDraftDto } from '../models/OK/Egis/Service/Models/DTO/slutopgoerelse-draft-dto';
import { SlutopgoerelseDraftRequestDto as OkEgisServiceModelsDtoSlutopgoerelseDraftRequestDto } from '../models/OK/Egis/Service/Models/DTO/slutopgoerelse-draft-request-dto';
import { SlutopgoerelseDto as OkEgisServiceModelsDtoSlutopgoerelseDto } from '../models/OK/Egis/Service/Models/DTO/slutopgoerelse-dto';
import { SlutopgoerelseUpdateDto as OkEgisServiceModelsDtoSlutopgoerelseUpdateDto } from '../models/OK/Egis/Service/Models/DTO/slutopgoerelse-update-dto';
import { SlutopgoerelseWithServiceaftaleDto as OkEgisServiceModelsDtoSlutopgoerelseWithServiceaftaleDto } from '../models/OK/Egis/Service/Models/DTO/slutopgoerelse-with-serviceaftale-dto';

@Injectable({
  providedIn: 'root',
})
export class SlutopgoerelseService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getOverdueSlutopgoerelser
   */
  static readonly GetOverdueSlutopgoerelserPath = '/api/v1/Slutopgoerelse/GetOverdueSlutopgoerelser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOverdueSlutopgoerelser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverdueSlutopgoerelser$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoSlutopgoerelseWithServiceaftaleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SlutopgoerelseService.GetOverdueSlutopgoerelserPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoSlutopgoerelseWithServiceaftaleDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOverdueSlutopgoerelser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverdueSlutopgoerelser(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoSlutopgoerelseWithServiceaftaleDto>> {

    return this.getOverdueSlutopgoerelser$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoSlutopgoerelseWithServiceaftaleDto>>) => r.body as Array<OkEgisServiceModelsDtoSlutopgoerelseWithServiceaftaleDto>)
    );
  }

  /**
   * Path part for operation updateSlutopgoerelse
   */
  static readonly UpdateSlutopgoerelsePath = '/api/v1/Slutopgoerelse/UpdateSlutopgoerelse';

  /**
   * Updates a slutopgørelse.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSlutopgoerelse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSlutopgoerelse$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoSlutopgoerelseUpdateDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoSlutopgoerelseDto>> {

    const rb = new RequestBuilder(this.rootUrl, SlutopgoerelseService.UpdateSlutopgoerelsePath, 'put');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoSlutopgoerelseDto>;
      })
    );
  }

  /**
   * Updates a slutopgørelse.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateSlutopgoerelse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSlutopgoerelse(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoSlutopgoerelseUpdateDto
  }): Observable<OkEgisServiceModelsDtoSlutopgoerelseDto> {

    return this.updateSlutopgoerelse$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoSlutopgoerelseDto>) => r.body as OkEgisServiceModelsDtoSlutopgoerelseDto)
    );
  }

  /**
   * Path part for operation afregnSlutopgoerelse
   */
  static readonly AfregnSlutopgoerelsePath = '/api/v1/Slutopgoerelse/AfregnSlutopgoerelse';

  /**
   * Updates a slutopgørelse.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `afregnSlutopgoerelse()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  afregnSlutopgoerelse$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoSlutopgoerelseAfregnRequestDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SlutopgoerelseService.AfregnSlutopgoerelsePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Updates a slutopgørelse.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `afregnSlutopgoerelse$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  afregnSlutopgoerelse(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoSlutopgoerelseAfregnRequestDto
  }): Observable<void> {

    return this.afregnSlutopgoerelse$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getOverdueSlutopgoerelserCount
   */
  static readonly GetOverdueSlutopgoerelserCountPath = '/api/v1/Slutopgoerelse/GetOverdueSlutopgoerelserCount';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOverdueSlutopgoerelserCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverdueSlutopgoerelserCount$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, SlutopgoerelseService.GetOverdueSlutopgoerelserCountPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOverdueSlutopgoerelserCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOverdueSlutopgoerelserCount(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<number> {

    return this.getOverdueSlutopgoerelserCount$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation getSlutopgoerelseDraft
   */
  static readonly GetSlutopgoerelseDraftPath = '/api/v1/Slutopgoerelse/GetSlutopgoerelseDraft';

  /**
   * Hent slutopgørelse kladde.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSlutopgoerelseDraft()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSlutopgoerelseDraft$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoSlutopgoerelseDraftRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoSlutopgoerelseDraftDto>> {

    const rb = new RequestBuilder(this.rootUrl, SlutopgoerelseService.GetSlutopgoerelseDraftPath, 'put');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoSlutopgoerelseDraftDto>;
      })
    );
  }

  /**
   * Hent slutopgørelse kladde.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSlutopgoerelseDraft$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSlutopgoerelseDraft(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoSlutopgoerelseDraftRequestDto
  }): Observable<OkEgisServiceModelsDtoSlutopgoerelseDraftDto> {

    return this.getSlutopgoerelseDraft$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoSlutopgoerelseDraftDto>) => r.body as OkEgisServiceModelsDtoSlutopgoerelseDraftDto)
    );
  }

}
